import { useState, useEffect, useRef } from "react";

export default function Fade({ children, delay = 0, scroll = true }) {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const container = ref.current;

        const checkVisibility = () => {
            const rect = container.getBoundingClientRect();
            if (rect.top <= window.innerHeight) {
                setIsVisible(true);
            }
        };

        const timeoutId = setTimeout(() => {
            checkVisibility();
            window.addEventListener("scroll", checkVisibility);
        }, delay * 1000);

        return () => {
            clearTimeout(timeoutId);
            window.removeEventListener("scroll", checkVisibility);
        };
    }, [delay]);

    return (
        <div ref={ref} className={`fade-in ${isVisible ? "is-visible" : ""} ${scroll ? "scroll" : ""}`}>
            {children}
        </div>
    );
}
